














































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MonitoringTrombolisisSvc from "@/services/MonitoringTrombolisisService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class MonitoringTrombolisisOutcome extends Vue {
  @Prop() monitoring!: any;
  @Prop({ default: false }) readonly!: boolean;

  isReadOnly!: () => boolean;
  get editWindowReadOnly(): boolean {
    return this.isReadOnly();
  }

  valid = true;
  saving = false;
  signing = false;
  showSignDialog = false;
  signRole = "";
  signPassword = "";

  disposisiOptions = [
    "Transfer ICU",
    "Transfer HCU",
    "Transfer Stroke Unit",
    "Rawat Inap Ruangan",
    "Rujuk",
    "Meninggal",
  ];

  form: any = {};

  mounted() {
    this.populateForm();
  }

  @Watch("monitoring")
  onMonitoringChange() {
    this.populateForm();
  }

  get currentUserId(): number {
    return Number(userModule.user?.id);
  }

  get dpjpSignBlockReason(): string {
    if (!this.monitoring.dpjp_id) {
      return "Pilih dan simpan DPJP / Neurologist pada Data Trombolisis terlebih dahulu.";
    }
    if (Number(this.monitoring.dpjp_id) !== this.currentUserId) {
      return `Hanya dapat ditandatangani oleh ${this.monitoring.dpjp?.nama || "DPJP yang tercatat pada form"}.`;
    }
    return "";
  }

  get perawatSignBlockReason(): string {
    if (!this.monitoring.perawat_id) {
      return "Pilih dan simpan Perawat Monitoring pada Data Trombolisis terlebih dahulu.";
    }
    if (Number(this.monitoring.perawat_id) !== this.currentUserId) {
      return `Hanya dapat ditandatangani oleh ${this.monitoring.perawat?.nama || "Perawat Monitoring yang tercatat pada form"}.`;
    }
    return "";
  }

  get nihssDelta() {
    if (this.monitoring.nihss_pre_tpa == null || this.form.nihss_24h_score == null) return null;
    return this.monitoring.nihss_pre_tpa - this.form.nihss_24h_score;
  }

  get nihssDeltaColor() {
    const d = this.nihssDelta;
    if (d == null) return "grey";
    if (d > 0) return "green";
    if (d < 0) return "red";
    return "grey";
  }

  get nihssDeltaText() {
    const d = this.nihssDelta;
    if (d == null) return "-";
    const sign = d > 0 ? "-" : "+";
    const label = d > 0 ? "Perbaikan" : d < 0 ? "Perburukan" : "Stabil";
    return `Delta: ${sign}${Math.abs(d)} ${label}`;
  }

  populateForm() {
    const m = this.monitoring;
    this.form = {
      ct_24h_dilakukan: m.ct_24h_dilakukan || false,
      ct_24h_at: m.ct_24h_at ? m.ct_24h_at.substring(0, 16) : "",
      ct_24h_hasil: m.ct_24h_hasil || "",
      ct_24h_ich: m.ct_24h_ich || false,
      nihss_1h_score: m.nihss_1h_score,
      nihss_24h_score: m.nihss_24h_score,
      outcome: m.outcome || null,
      disposisi: m.disposisi || null,
      monitoring_completed_at: m.monitoring_completed_at ? m.monitoring_completed_at.substring(0, 16) : "",
      catatan: m.catatan || "",
    };
  }

  async simpan() {
    if (this.editWindowReadOnly) return;
    this.saving = true;
    try {
      const resp = await MonitoringTrombolisisSvc.setOutcome(this.monitoring.id, this.form);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Outcome berhasil disimpan");
        this.$emit("saved", resp.data.data);
      }
    } catch { /* */ }
    this.saving = false;
  }

  openSignDialog(role: string) {
    if (role === "dpjp" ? this.dpjpSignBlockReason : this.perawatSignBlockReason) return;
    this.signRole = role;
    this.signPassword = "";
    this.showSignDialog = true;
  }

  async doSign() {
    if (this.editWindowReadOnly) return;
    this.signing = true;
    try {
      const resp = await MonitoringTrombolisisSvc.sign(this.monitoring.id, {
        role: this.signRole,
        password: this.signPassword,
      });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay(resp.data.message);
        this.showSignDialog = false;
        this.$emit("saved", { id: this.monitoring.id });
      }
    } catch { /* */ }
    this.signing = false;
  }

  cetakPdf() {
    MonitoringTrombolisisSvc.printPdf(this.monitoring.id);
  }
}
